import { render, staticRenderFns } from "./VxBreadcrumb.vue?vue&type=template&id=18429fea"
import script from "./VxBreadcrumb.vue?vue&type=script&lang=js"
export * from "./VxBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./VxBreadcrumb.vue?vue&type=style&index=0&id=18429fea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports